import { FILES, isSquare } from './types.js';
const BACK_RANK = ['r', 'n', 'b', 'q', 'k', 'b', 'n', 'r'];
const COLORS = ['w', 'b'];
const TYPES = ['p', 'n', 'b', 'r', 'q', 'k'];
/**
 * The standard starting position for one colour, as a square→piece map.
 * Used to seed the phantom opponent-model layer with the opponent's army.
 */
export function opponentStartPosition(opponentColor) {
    const backRank = opponentColor === 'w' ? '1' : '8';
    const pawnRank = opponentColor === 'w' ? '2' : '7';
    const out = {};
    FILES.forEach((file, i) => {
        out[`${file}${backRank}`] = { color: opponentColor, type: BACK_RANK[i] };
        out[`${file}${pawnRank}`] = { color: opponentColor, type: 'p' };
    });
    return out;
}
/**
 * Parse a persisted phantom map (from localStorage). Tolerant: returns {} on
 * any structural failure and silently drops individual invalid entries.
 */
export function deserializePhantoms(raw) {
    if (!raw)
        return {};
    let parsed;
    try {
        parsed = JSON.parse(raw);
    }
    catch {
        return {};
    }
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed))
        return {};
    const out = {};
    for (const [k, v] of Object.entries(parsed)) {
        if (!isSquare(k))
            continue;
        if (typeof v !== 'object' || v === null)
            continue;
        const { color, type } = v;
        if (!COLORS.includes(color))
            continue;
        if (!TYPES.includes(type))
            continue;
        out[k] = { color: color, type: type };
    }
    return out;
}
